import Inbox from '@/components/Inbox';

import '@/styles/index.scss';
import './InboxPage.scss';

export default function InboxPage() {
  return (
    <Inbox />
  );
}
